import { __assign } from "tslib";
import { makeStyles, shorthands } from '@fluentui/react-components';
export var useActionMenuPopoverStyles = makeStyles({
    popOver: __assign({}, shorthands.padding('2px')),
    menuItemsNoOutline: {
        '& div': {
            ':hover': {
                outlineStyle: 'none',
            },
            ':active:hover': {
                outlineStyle: 'none',
            },
            ':focus-visible': {
                outlineStyle: 'none',
            },
        },
    },
});
//# sourceMappingURL=ActionContextMenuPopover.styles.js.map